import React from 'react'
import { useTranslation } from 'react-i18next'
import { ToggleButtonGroup, ToggleButton, Tooltip } from '@mui/material'
import ViewListIcon from '@mui/icons-material/ViewList'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'

export type ViewMode = 'list' | 'calendar'

interface ViewToggleProps {
    viewMode: ViewMode
    onViewModeChange: (mode: ViewMode) => void
}

export function ViewToggle({ viewMode, onViewModeChange }: ViewToggleProps) {
    const { t } = useTranslation()

    const handleChange = (_event: React.MouseEvent<HTMLElement>, newMode: ViewMode | null) => {
        if (newMode !== null) {
            onViewModeChange(newMode)
        }
    }

    return (
        <ToggleButtonGroup
            value={viewMode}
            exclusive
            onChange={handleChange}
            aria-label="view mode"
            size="small"
            data-testid="shift-marketplace-view-toggle"
        >
            <Tooltip title={t('page.shiftMarketplace.listView', 'List View')}>
                <ToggleButton value="list" aria-label="list view" data-testid="shift-marketplace-list-view-button">
                    <ViewListIcon />
                </ToggleButton>
            </Tooltip>
            <Tooltip title={t('page.shiftMarketplace.calendarView', 'Calendar View')}>
                <ToggleButton value="calendar" aria-label="calendar view" data-testid="shift-marketplace-calendar-view-button">
                    <CalendarMonthIcon />
                </ToggleButton>
            </Tooltip>
        </ToggleButtonGroup>
    )
}

export default ViewToggle
